"use strict";
import {
  OPENOCEAN_API_BASE,
  OPENOCEAN_DEFAULT_GAS_PRICE_WEI,
  clampOpenOceanSlippage,
  getOpenOceanChainPath
} from "features/openocean/constants";
function buildQueryString(params) {
  const qs = new URLSearchParams({
    inTokenAddress: params.inTokenAddress,
    outTokenAddress: params.outTokenAddress,
    amountDecimals: params.amountDecimals,
    gasPriceDecimals: params.gasPriceDecimals ?? OPENOCEAN_DEFAULT_GAS_PRICE_WEI
  });
  qs.set("slippage", clampOpenOceanSlippage(params.slippagePercent ?? 1).toString());
  if (params.account) {
    qs.set("account", params.account);
  }
  return qs.toString();
}
async function fetchOpenOcean(action, params) {
  const chainPath = getOpenOceanChainPath(params.chainId);
  if (!chainPath) {
    throw new Error(`OpenOcean is not supported on chain ${params.chainId}`);
  }
  const url = `${OPENOCEAN_API_BASE}?path=v4/${chainPath}/${action}&${buildQueryString(params)}`;
  const res = await fetch(url);
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const reason = body?.error || body?.message || body?.reason || res.statusText;
    throw new Error(`OpenOcean ${action} error: ${reason}`);
  }
  if (body?.code !== void 0 && body.code !== 200) {
    throw new Error(`OpenOcean ${action} error: ${body?.error || body?.message || body?.reason || body.code}`);
  }
  if (!body?.data) {
    throw new Error(`OpenOcean ${action} error: empty response`);
  }
  if (action === "swap") {
    const data = body.data;
    if (!data.to || !data.data || data.value === void 0) {
      throw new Error("OpenOcean swap error: response missing transaction fields (to/data/value)");
    }
  }
  return body.data;
}
export function fetchOpenOceanQuote(params) {
  return fetchOpenOcean("quote", params);
}
export function fetchOpenOceanSwap(params) {
  if (!params.account) {
    throw new Error("OpenOcean /swap requires an account address");
  }
  return fetchOpenOcean("swap", params);
}
